import { readable } from 'svelte/store';

const lookups = readable(window.lookups);

export default lookups;